<template lang="pug">
  div
    v-app-bar(color="#AD342D" flat)
      v-toolbar-title.white--text
        div
          v-img.pa-0.ma-0(:src=" require('@/assets/images/logo_main.png')" height="24px" style="max-width:76px" :contain="logo")

</template>

<script>
export default {
  name: 'HeadBar',
  props: ['logo']
}
</script>